import cx from 'classnames'

import { TableCell } from '../cell'
import { styles } from './table-row.styles'
import type { TableRowProps } from './table-row.types'

export function TableRow({
  isHeading = false,
  cells,
  className,
  ...rowProps
}: TableRowProps) {
  const as = isHeading ? 'th' : 'td'

  return (
    <tr className={cx(styles.base, className)} {...rowProps}>
      {cells.map((cell, cellIndex) => (
        <TableCell key={`cell-${cellIndex}`} as={as} {...cell} />
      ))}
    </tr>
  )
}
